// removed by extract-text-webpack-plugin
module.exports = {"ptm-checkoutjs-lg-wrapper":"_2T9r","ptm-checkoutjs-container":"_2TUj","ptm-checkoutjs-footer":"_2Sad","ptm-checkoutjs-footer-container":"_2HOP","ptm-checkoutjs-f-i-container":"_27SO","ptm-checkoutjs-b-f-container":"_12og","b1-style":"_ibc-","b2-style":"_2Ic2"};


//////////////////
// WEBPACK FOOTER
// ./form/components/checkoutjs/style.css
// module id = d/uS
// module chunks = 4